import {v4} from "uuid";
import {useEffect, useState} from "react";
import {Button, notification, Spin, Table, Typography} from "antd";
import renderKey from "./Output/RenderService";
import {OPS_STATUS} from "./OperationManager";
import {CloseOutlined} from "@ant-design/icons";
import {useUser} from "../Context/UserContext";
import {useProject} from "../Context/ProjectContext";
import FilterText from "./FilterText";
import OutputError from "./Output/OutputError";

export default function CheckResult2({data, status, noIssueText, report, settings, type}) {
    const id = v4()
    const {user} = useUser()
    const [resultComponent, setResultComponent] = useState([])
    const {filter} = useProject()

    const copyTable = () => {
        const elTable = document.getElementById(id).getElementsByTagName('table')[0]

        let range, sel;

        if (document.createRange && window.getSelection) {

            range = document.createRange();
            sel = window.getSelection();
            // unselect any element in the page
            sel.removeAllRanges();

            try {
                range.selectNodeContents(elTable);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(elTable);
                sel.addRange(range);
            }

            document.execCommand('copy');
        }

        sel.removeAllRanges();
        notification.success({
            message: 'Result Copied!'
        })
    }


    useEffect(() => {
        if(data)
            setResultComponent(renderKey.renderOutput({
                key: data.key,
                result: data.result,
                errors: data.errors,
                globalVariables: data.global_variables,
                settings: user.settings,
                filter: type === 'check' ? filter.check : filter.comparison,
            }))
    }, [data, filter])

    const renderStatus = () => {
        if(status === OPS_STATUS.CHECKING) {
            return (
                <div style={{width: 200, display: 'flex', alignItems:'center', gap: 8}}>
                    <Spin />
                </div>
            )
        }

        if(status === OPS_STATUS.ERROR) {
            return (
                <div style={{width: 300, display: 'flex', alignItems:'center', gap: 8}}>
                    <span>
                        Calculation could not be completed
                    </span>
                    <span style={{color: '#ee5253'}}><CloseOutlined /></span>
                </div>
            )
        }

        // if(data?.result?.find(x => x && x.error_id && x.error_id === 'NO-OUT-00')) {
        //     return <OutputError />
        // }

        if(data?.result?.length === 0 || !data?.result?.find(x => x?.data?.length > 0 || !(x?.data))) {
            return (
                <div style={{width: 400, display: 'flex', alignItems:'center', gap: 8}}>
                    <img src={'/success_res.png'} width={36} height={36} alt={''}/>
                    <div>
                        {noIssueText || `No found Issue`}
                    </div>
                </div>
            )
        }
        else if(!data || !data.result) {
            return (
                <div style={{width: 200, display: 'flex', alignItems:'center', gap: 8}}>
                    <img src={'/info.png'} width={36} height={36} alt={''}/>
                    <div>
                        Please Run
                    </div>
                </div>
            )
        }
    }

    return (
        <div style={{padding: 24}}>
            {!report && renderStatus()}
            {
                status !== OPS_STATUS.CHECKING && data?.result?.length > 0 && data?.result?.find(x => x?.data?.length > 0 || !(x?.data)) && (
                    <>
                        {resultComponent}
                    </>
                )
            }
        </div>
    )
}